import React from 'react';
import Header from '../components/Header';
import ITLabs from '../components/ITLabs';
import Footer from '../components/Footer';

function ITLabsPage() {
  return (
    <>
      <Header />
      <div className="pt-16 md:pt-20">
        <ITLabs />
      </div>
      <Footer />
    </>
  );
}

export default ITLabsPage;
